  const fieldset = document.querySelector('.product-form__input--pill');
  const variantset = document.querySelector('variant-selects');

  const lvOptions = document.querySelectorAll('.lv-option-wrapper');
  if(lvOptions?.length > 0) {
    lvOptions.forEach( (option)  => {
      const handle = option.querySelector('.lv-option-item')?.getAttribute('data-handle');
      const handleValue = localStorage.getItem(handle);
      if(handleValue !== null){
        const input = fieldset.querySelector(`input[value="${handleValue}"]`);
        localStorage.removeItem(handle);
        input.click();
        variantset.dispatchEvent(new Event("change"));
      }
    });
  }